<template lang="pug">
  v-layout.text-xs-right(row)
    v-flex(xs12)
      v-btn.primary--text(icon @click="decrease" :disabled = "disabled" small) 
        v-icon remove_circle
      span(style="width: 15px; text-align: center;" :class="{disabled: disabled}" ) {{val}}
      v-btn.primary--text(icon @click="increase" :disabled="disabled" small )
        v-icon() add_circle
</template>
<script>
export default {
  props:{
    val:{
      default: 1
    },
    disabled:{
      default: false
    }
   },
  methods:{
    decrease(){
      this.$emit('decrement')
    },
    increase(){
      this.$emit('increment')
    }
  }
}
</script>
<style scoped>
  .disabled{
    color: lightgrey;
  }
</style>


